import get from 'lodash/get'

import { isWhiteLabel } from 'utils/whiteLabel'
import { useWhitelabelCateringEnabled } from 'utils/featureFlag'

/**
 * Whether a venue gets the catering flow: the order-details bar, the catering
 * review and status pages, and ordering while the venue is closed. It needs a
 * whitelabel site, a venue flagged `isCatering`, and the
 * `enable-whitelabel-catering` Flipt flag (web-consumer namespace, off by
 * default). Every catering gate reads this, so the flag turns the whole flow
 * on or off in one place.
 */
export const isCateringVenue = (venue) =>
  !!get(venue, 'isCatering') && isWhiteLabel() && useWhitelabelCateringEnabled()

/**
 * The catering review and status pages. They render the same components as
 * /order/:id/review and /order/:id/status, which branch on isCateringVenue.
 * Stripe Checkout returns here: the API's whitelabel cancel_url is the review
 * path (with ?reload-cart=true) and its success_url is the status path. The
 * /order paths keep working because the API sends one URL pair for every
 * whitelabel order, catering or not.
 */
export const CATERING_REVIEW_PATH = '/catering/order/:id/review'
export const CATERING_STATUS_PATH = '/catering/order/:id/status'

export const reviewUrl = (venueId, isCatering) =>
  `${isCatering ? '/catering' : ''}/order/${venueId}/review`

export const statusUrl = (orderId, isCatering) =>
  `${isCatering ? '/catering' : ''}/order/${orderId}/status`
